<template>
	<div v-if="!unitData.style || unitData.style == 'channel_product_col2_1'" class="m-channel-product flex-between style1">
		<ul>
			<template v-for="(item, i) in unitData.product_list">
				<li v-if="i % 2 == 0" :key="item.product_id" class="item style1">
					<sub-image class="image" :src="item.product_img_url" mode="widthFix"></sub-image>
					<div class="info">
						<p class="name ellipsis-2">{{item.product_name}}</p>
						<div v-if="unitData.is_point == 1" class="price">{{item.sale_price}}积分</div>
						<div v-else class="price">￥{{item.sale_price}}</div>
						<div class="tag flex-center-cross">
							<label>新品</label>
						</div>
					</div>
				</li>
			</template>
		</ul>
		<ul>
			<template v-for="(item, i) in unitData.product_list">
				<li v-if="i % 2 == 1" :key="item.product_id" class="item style1">
					<sub-image class="image" :src="item.product_img_url" mode="widthFix"></sub-image>
					<div class="info">
						<p class="name ellipsis-2">{{item.product_name}}</p>
						<div v-if="unitData.is_point == 1" class="price">{{item.sale_price}}积分</div>
						<div v-else class="price">￥{{item.sale_price}}</div>
						<div class="tag flex-center-cross">
							<label>新品</label>
						</div>
					</div>
				</li>
			</template>
		</ul>
	</div>
	
	<div v-else-if="unitData.style == 'channel_product_col2_2'" class="m-channel-product flex-between style2">
		<ul>
			<template v-for="(item, i) in unitData.product_list">
				<li v-if="i % 2 == 0" :key="item.product_id" class="item style2">
					<sub-image class="image" :src="item.product_img_url" mode="widthFix"></sub-image>
					<div class="info">
						<p class="name ellipsis-2">{{item.product_name}}</p>
						<div v-if="unitData.is_point == 1" class="price">{{item.sale_price}}积分</div>
						<div v-else class="price">￥{{item.sale_price}}</div>
						<div class="button">立即购买</div>
					</div>
				</li>
			</template>
		</ul>
		<ul>
			<template v-for="(item, i) in unitData.product_list">
				<li v-if="i % 2 == 1" :key="item.product_id" class="item style2">
					<sub-image class="image" :src="item.product_img_url" mode="widthFix"></sub-image>
					<div class="info">
						<p class="name ellipsis-2">{{item.product_name}}</p>
						<div v-if="unitData.is_point == 1" class="price">{{item.sale_price}}积分</div>
						<div v-else class="price">￥{{item.sale_price}}</div>
						<div class="button">立即购买</div>
					</div>
				</li>
			</template>
		</ul>
	</div>
	
	<div v-else-if="unitData.style == 'channel_product_col1_1'" class="m-channel-product style3">
		<ul>
			<li v-for="(item, i) in unitData.product_list" :key="item.product_id" class="item style3 flex">
				<sub-image class="image" :src="item.product_img_url"></sub-image>
				<div class="info flex-grow flex-column flex-between">
					<p class="name ellipsis-2">{{item.product_name}}</p>
					<div class="button">
						<p>预估到手价</p>
						<strong v-if="unitData.is_point == 1">{{parseFloat(item.sale_price)}}积分</strong>
						<strong v-else>￥{{parseFloat(item.sale_price)}}</strong>
					</div>
				</div>
			</li>
		</ul>
	</div>
	
	<div v-else-if="unitData.style == 'channel_product_col1_2'" class="m-channel-product style4">
		<ul>
			<li v-for="(item, i) in unitData.product_list" :key="item.product_id" class="item style4 flex">
				<sub-image class="image" :src="item.product_img_url"></sub-image>
				<div class="info flex-grow flex-column flex-between">
					<p class="name ellipsis-2">{{item.product_name}}</p>
					<div class="button">
						<strong v-if="unitData.is_point == 1">{{parseFloat(item.sale_price)}}积分</strong>
						<strong v-else>￥{{parseFloat(item.sale_price)}}</strong>
						<p>超值低价，省36.5元</p>
					</div>
				</div>
			</li>
		</ul>
	</div>
	
	<div v-else-if="unitData.style == 'channel_product_col3_1'" class="m-channel-product style5">
		<ul class="flex-wrap">
			<li v-for="(item, i) in unitData.product_list" :key="item.product_id" class="item style5">
				<sub-image class="image" :src="item.product_img_url"></sub-image>
				<div class="info">
					<p class="name ellipsis-2">{{item.product_name}}</p>
					<div v-if="unitData.is_point == 1" class="price">{{item.sale_price}}积分</div>
					<div v-else class="price">￥{{parseFloat(item.sale_price)}}<del>￥{{item.original_sale_price}}</del></div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-channel-product {
		&.style1 {
			padding: 7px 0;
		}
		
		&.style2 {
			padding: 10px;
		}
		
		&.style3 {
			padding: 12px 0;
			border-radius: 10px;
			background: #fff;
		}
		
		&.style4 {
			padding: 10px;
		}
		
		&.style5 {
			padding: 10px;
		}
		
		.item {
			box-sizing: border-box;
			overflow: hidden;
			background: #fff;
			
			&.style1 {
				width: 186px;
				padding: 10px;
				
				&:nth-child(n+2) {
					margin-top: 3px;
				}
				
				.image {
					width: 166px;
					height: 166px;
				}
				
				.info {
					padding-top: 10px;
					
					.name {
						line-height: 20px;
						font-size: 13px;
						color: #333;
					}
					
					.price {
						margin-top: 2px;
						line-height: 20px;
						font-size: 15px;
						font-weight: bold;
					}
					
					.tag {
						height: 20px;
						margin-top: 4px;
						
						label {
							border: 1px solid #DE1B24;
							padding: 0 6px;
							margin-right: 4px;
							line-height: 14px;
							font-size: 12px;
							color: #DE1B24;
						}
					}
				}
			}
			
			&.style2 {
				width: 174px;
				
				&:nth-child(n+2) {
					margin-top: 7px;
				}
				
				.image {
					width: 174px;
					height: 174px;
				}
				
				.info {
					padding: 5px 10px 11px;
					
					.name {
						line-height: 20px;
						font-size: 13px;
						text-align: center;
						color: #333;
					}
					
					.price {
						margin: 6px 0 10px;
						font-size: 15px;
						font-weight: bold;
						text-align: center;
					}
					
					.button {
						width: 70px;
						margin: 0 auto;
						line-height: 24px;
						font-size: 12px;
						text-align: center;
						color: #fff;
						background: #000;
					}
				}
			}
			
			&.style3 {
				padding: 12px 10px;
				
				.image {
					width: 140px;
					height: 140px;
					margin-right: 15px;
				}
				
				.info {
					.name {
						line-height: 22px;
						font-size: 15px;
						font-weight: bold;
					}
					
					.button {
						height: 55px;
						padding-left: 10px;
						background-image: url('~@/submodule/assets/image/decorate/app_channel_product_col1_1_btn.png');
						background-size: 100% 100%;
						
						p {
							margin: 8px 0 10px;
							font-size: 12px;
							color: #E3453C;
						}
						
						strong {
							font-size: 18px;
							color: #FF0E00;
						}
					}
				}
			}
			
			&.style4 {
				height: 134px;
				border-radius: 6px;
				padding: 12px;
				
				&:nth-child(n+2) {
					margin-top: 10px;
				}
				
				.image {
					width: 110px;
					height: 110px;
					margin-right: 20px;
				}
				
				.info {
					.name {
						line-height: 20px;
						font-size: 15px;
						font-weight: bold;
					}
					
					.button {
						height: 44px;
						padding-left: 15px;
						background-image: url('~@/submodule/assets/image/decorate/app_channel_product_col1_2_btn.png');
						background-size: 100% 100%;
						
						strong {
							display: block;
							margin: 5px 0 4px;
							font-size: 18px;
							color: #F30000;
						}
						
						p {
							font-size: 12px;
							color: #F30000;
						}
					}
				}
			}
			
			&.style5 {
				width: 113px;
				border-radius: 4px;
				margin-left: 8px
				overflow: hidden;
				
				&:nth-child(3n+1) {
					margin-left: 0;
				}
				
				&:nth-child(n+4) {
					margin-top: 8px;
				}
				
				.image {
					height: 113px;
				}
				
				.info {
					padding: 5px 10px 0;
					
					.name {
						height: 32px;
						line-height: 16px;
						font-size: 12px;
						color: #444;
					}
					
					.price {
						line-height: 30px;
						font-size: 15px;
						font-weight: bold;
						
						del {
							margin-left: 5px;
							font-size: 12px;
							font-weight: normal;
							color: #999;
						}
					}
				}
			}
		}
	}
</style>
